module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/gastos/formulario-gasto/formulario-gasto.component.scss
// module id = ./src/app/components/gastos/formulario-gasto/formulario-gasto.component.scss
// module chunks = main